module.exports = "/remote-dist/6b92a707267876d81a981f3715b1e091.png";